
import param from "jquery-param"
import URI from "urijs"

import {
  DesktopFilter,
  InputSelector,
} from "concepts/buildings/overseas_marketing/filter_bar/desktop"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
import DataRetriever from "app/data_retriever"
import Modal from "app/modal/show-modal"

import BuildingsOverseasMarketingShareBox from "concepts/buildings/overseas_marketing/share/box"


import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"


export class OverseasMarkingFilterBarDesktopCountry extends DesktopFilter {
  protected onShareClick(){
    const overseas_properties_listing_search_criteria_set_params =
      (this.get_form_data() as any).overseas_properties_listing_search_criteria_set
    Modal.showLoadingIndicator()

    const url_object = URI(Routes.apps_spacious_website_partials_country_level_overseas_marketing_projects_share_modal_path())
    url_object.query(param({
      locale:     I18n.locale,
      country_id: DataRetriever.get("country-id"),
      overseas_properties_listing_search_criteria_set: overseas_properties_listing_search_criteria_set_params,
    }))

    return q_ajax_3({
      url:      url_object.toString(),
      method:   "GET",
      dataType: "HTML",
    })
    .then(({data}) => {
      Modal.hideTopModal()
      Modal.showModalWithContent(data)
      BuildingsOverseasMarketingShareBox.create()
    })
  }
}


const Factory = {
  _instance: null as null | OverseasMarkingFilterBarDesktopCountry,
  instance(selector?: InputSelector){
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new OverseasMarkingFilterBarDesktopCountry(selector)
  },
}

export {
  Factory,
}
